import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import { withFormsy } from 'formsy-react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Messages from './Messages';
import s from './Input.css';

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canDisplayError: false,
    };
    this.displayError = this.displayError.bind(this);
    this.changeValue = this.changeValue.bind(this);
  }

  // setValue() will set the value of the component, which in
  // turn will validate it and the rest of the form
  changeValue(event) {
    const value = event.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value'];
    this.props.setValue(value);

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }
  displayError(event) {
    this.setState({
      canDisplayError: true,
    });
    this.changeValue(event);
  }
  render() {
    // Set a specific className based on the validation
    // state of this component. showRequired() is true
    // when the value is empty and the required prop is
    // passed to the input. showError() is true when the
    // value typed is invalid
    let className = this.props.className;
    if (this.props.showRequired()) {
      className = classNames(s.required, s[className]);
    } else if (this.props.showError()) {
      className = classNames(s.error, s[className]);
    }

    const { intl } = this.props;
    const messages = Messages();

    const inputClassNames = classNames(
      s.Form_field,
      s.Form_field__small);
    // const inputClassNames = classNames({
    //   'Form_field': true,
    //   'Form_field__small': !!this.props.small,
    //   'Form_field__large': !!this.props.large,
    //   'Form_field__withoutBorder': !!this.props.withoutBorder,
    // });

    // An error message is returned ONLY if the component is invalid
    // or the server has returned an error message
    const errorMessage = 
      this.props.getErrorMessage() 
      || (this.props.showRequired() 
      && this.props.isFormSubmitted() 
      ? intl.formatMessage({...messages.field_required}) 
      : null);

    return (
      <div className={className}>
        {this.props.titleVisibility ? (
        <label htmlFor={this.props.name}>
          <span>{this.props.title}</span>
        </label>) : null}
        <input
          ref={(input) => this.input = input}
          className={inputClassNames}
          type={this.props.type || 'text'}
          name={this.props.name}
          id={this.props.name}
          disabled = {this.props.disabled ? 'disabled' : null}
          onChange={this.changeValue}
          onBlur={this.displayError}
          onSubmit={this.props.onSubmit}
          autoFocus={this.props.autofocus}
          value={this.props.getValue()}
          checked={this.props.type === 'checkbox' && this.props.getValue() ? 'checked' : null}
          placeholder={this.props.title}
        />
        {(this.state.canDisplayError || this.props.isFormSubmitted()) && errorMessage ? (
          <div className={s.Form_error}>
            <span>{errorMessage}</span>
          </div>) : null}
      </div>
    );
  }
};

Input.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  titleVisibility: PropTypes.bool,
  autofocus: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  large: PropTypes.bool,
  small: PropTypes.bool,
  withoutBorder: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  intl: intlShape.isRequired,
};

Input.defaultProps = {
  large: false,
  titleVisibility: false,
};


export default injectIntl(withFormsy(withStyles(s)(Input, { withRef: true })));



// WEBPACK FOOTER //
// ./src/components/Input/Input.js